export function dollarsToMinor(value: string): number | undefined {
  const amount = Number(value);
  return Number.isFinite(amount) && amount >= 0 ? Math.round(amount * 100) : undefined;
}

export function batchHref(batchId: string): string {
  return `/storage/batches/${encodeURIComponent(batchId)}`;
}

export function formatMoneyMinor(value: number | undefined): string {
  return value === undefined ? 'Not set' : `$${(value / 100).toFixed(2)}`;
}

const consignmentErrorMessages: Readonly<Record<string, string>> = {
  batch_assignment_too_large: 'This batch is too large to assign in one operation.',
  cards_already_owned: 'This batch contains cards already assigned to another consignment.',
  intake_not_open: 'This intake is no longer open.',
  marketplace_committed_cards_cannot_be_assigned:
    'This batch contains cards already approved, exported, listed, or sold in a marketplace. Assign an uncommitted batch or resolve those cards first.',
  retired_cards_cannot_be_assigned: 'This batch contains retired cards and cannot be assigned.',
};

export function consignmentErrorMessage(result: { error: string; message?: string }): string {
  const code = result.message ?? result.error;
  return consignmentErrorMessages[code] ?? code;
}
